/**
 * MobileMixerToggle Component
 * Button to open mixer panel on mobile devices
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Menu } from 'lucide-react';

export const MobileMixerToggle = ({
  isMobile,
  showMixer,
  setShowMixer,
}) => {
  if (!isMobile || showMixer) return null;
  
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setShowMixer(true)}
      className="absolute left-2 top-2 z-20 bg-zinc-800/80 backdrop-blur-sm"
      data-testid="open-mixer"
    >
      <Menu className="w-4 h-4 mr-1" />
      Mixer
    </Button>
  );
};

export default MobileMixerToggle;
